import React from "react";
import ReactDOM from "react-dom";
import "../componentes/styles/Modal.css";

function ModalFpay2({ isOpen, handleKeyUp, onClose, children, title }) {
  if (!isOpen) {
    return null;
  }

  const _handleKeyUp =
    handleKeyUp ||
    (e => {
      if (e.key === "Escape") onClose();
    });

  return ReactDOM.createPortal(
    <div
      className="Modal"
      tabIndex="-1"
    >
      <div className="contenedor" onMouseDown={e => e.stopPropagation()} >
        <div className="header">
          <label>{title}</label>
        </div>
        <div className="body">
          {children}
        </div>
      </div>
    </div>,
    document.getElementById("modal")
  );
}

export default ModalFpay2;
